import Scene = Phaser.Scene;
import {ResourceType} from "@/store/place/types";
import ResourceUtils from "@/utils/resource-utils";
import {Player} from "@/store/player/types";
import {ResSubpanel} from "@/scenes.ui/res-subpanel";
import {ResourceContainer} from "@/scenes.ui/resource-container";
import {PositionUtils} from "@/utils/position-utils";
import CU from "@/utils/c-u";

export class ResPanel extends ResourceContainer {

    private static readonly CELL_SIZE_X = 70;
    private static readonly CELL_SIZE_Y = 40;

    public panelByRes: Map<ResourceType, ResSubpanel> = new Map();

    constructor(scene: Scene, x: number, y: number, player: Player) {
        super(scene);
        let self = this;

        this.scene = scene;
        this.x = CU.shiftLeft(6);
        this.y = CU.shiftTop(83 + PositionUtils.getPositioner().getButtonsTopY());
        this.setDefaultDepth();

        let resources: Map<ResourceType, number> = ResourceUtils.convertToBalance(player);

        let group = this.scene.add.group();

        for (let [key, value] of resources) {

            const resText = new ResSubpanel(scene, 40, 0, key, value);

            let container = this.scene.add.container(0, 0, resText);
            group.add(container);
            self.add(container);

            this.panelByRes.set(key, resText);
        }

        Phaser.Actions.GridAlign(group.getChildren(), {
            cellWidth: CU.scale(ResPanel.CELL_SIZE_X),
            cellHeight: CU.scale(ResPanel.CELL_SIZE_Y),
            width: 1,
            height: resources.size,
            x: 0,
            y: 0
        });

        for (let obj of group.getChildren()) {
            this.add(obj);
        }
    }

    public setDefaultDepth() {
        this.setDepth(999);
    }

    public setTopDepth() {
        this.setDepth(4000);
    }

    public setBalance(player: Player) {
        let resources: Map<ResourceType, number> = ResourceUtils.convertToBalance(player);
        if (this.panelByRes && resources) {
            for (let [key, value] of resources) {
                if (this.panelByRes.get(key) && this.panelByRes.get(key)!.active) {
                    this.panelByRes.get(key)!.setBalance(value);
                }
            }
        }
    }

    public setOrigin(x: number, y: number): void {
        // do nothing
    }
}
